import { AtsJobClass } from "src/classes/ats/job";
import useNavigateCreateJob from "src/hooks/navigate/useNavigateCreateJob";
import { AtsJob } from "src/types/merge_ats";

// This hooks takes care of deciphering slugs and providing id and slug from params
function useImportJob() {
  const { goToCreateJobs } = useNavigateCreateJob();

  const go = (j: AtsJob) => {
    const J = new AtsJobClass(j);
    goToCreateJobs({ default: J.toOutdefineJobForm() });
  };

  return { importJob: go };
}

export default useImportJob;
